import React from 'react';
import './PagePortal.scss';
const PagePortal = props => {
  return <div className="pageportal">{props.children}</div>;
};

export default PagePortal;
